import { History } from 'lucide-react';
import type { AdminAuditRecord } from '../types';

interface AuditFeatureProps {
  readonly records: readonly AdminAuditRecord[];
}

export function AuditFeature({ records }: AuditFeatureProps) {
  return (
    <section className="admin-feature" aria-labelledby="admin-audit-title">
      <div className="admin-feature__heading">
        <div>
          <span className="admin-eyebrow">Audit-Protokoll</span>
          <h2 id="admin-audit-title">Änderungen bleiben nachvollziehbar</h2>
        </div>
        <History size={22} />
      </div>

      <div className="admin-audit-list">
        {records.map((record) => (
          <article className="admin-audit-item" key={record.id}>
            <span className="admin-audit-item__dot" />
            <div>
              <div className="admin-audit-item__headline">
                <strong>{record.action}</strong>
                <time dateTime={record.occurredAt}>{new Date(record.occurredAt).toLocaleString('de-DE')}</time>
              </div>
              <p>{record.entity} · {record.detail}</p>
              <small>durch {record.actor}</small>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
}
